import type { Path, To } from 'react-router';

import { Navigate, useLocation } from 'react-router';

import { bypassBlocker } from '~/constants/router';

type Props = {
  state?: Record<PropertyKey, unknown>;
  to: To;
};

export const Redirect = ({ state, to }: Props) => {
  const location = useLocation();

  const destination: Partial<Path> =
    typeof to === 'string'
      ? { pathname: to, search: location.search, hash: location.hash }
      : { pathname: to.pathname, search: to.search ?? location.search, hash: to.hash ?? location.hash };

  return <Navigate replace state={{ ...bypassBlocker, ...state }} to={destination} />;
};
